var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgExport28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21C6 21.2652 6.10536 21.5196 6.29289 21.7071C6.48043 21.8946 6.73478 22 7 22L21 22C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21L22 15L24 15L24 21C24 21.7956 23.6839 22.5587 23.1213 23.1213C22.5587 23.6839 21.7957 24 21 24L7 24C6.20435 24 5.44129 23.6839 4.87868 23.1213C4.31607 22.5587 4 21.7957 4 21L4 15L6 15L6 21ZM8.29289 9.2929L14 3.5858L19.7071 9.2929L18.2929 10.7071L15 7.4142L15 17L13 17L13 7.4142L9.70711 10.7071L8.29289 9.2929Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExport28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;